/**
 * Essentiality Claim Chat API 接口定义
 */
import type { PsHttpSSE } from '@patsnap/common-ps-http';
import type { IEssentialityClaimSSEResponse } from '../types/essentiality-claim-types';

// 创建会话请求
export interface ICreateClaimChatRequest {
    patent_id?: string;
    claim_text?: string;
    standard_id?: string;
    new_chat?: boolean;
}

// 创建会话响应
export interface ICreateClaimChatResponse {
    chat_id: string;
    new_chat: boolean;
}

// 发送消息请求
export interface ISendClaimMessageRequest {
    chat_id: string;
    message: string;
    context?: {
        patent_id?: string;
        claim_id?: string;
        standard_id?: string;
    };
}

// 发送消息响应
export interface ISendClaimMessageResponse {
    message_id: string;
    success: boolean;
}

// 分析 Claim 请求
export interface IAnalyzeClaimRequest {
    chat_id: string;
    claim_text: string;
    patent_id?: string;
    standard_id?: string;
}

// 分析 Claim 响应
export interface IAnalyzeClaimResponse {
    task_id: string;
    success: boolean;
}

// Essentiality Claim Chat API 接口
export interface IEssentialityClaimChatApi {
    /**
     * 创建或获取聊天会话
     */
    createChat(request: ICreateClaimChatRequest): Promise<ICreateClaimChatResponse>;

    /**
     * 发送消息并开始对话
     */
    sendMessage(request: ISendClaimMessageRequest): Promise<ISendClaimMessageResponse>;

    /**
     * 获取 SSE 消息流
     */
    getMessageStream(chatId: string, lastMessageId?: string): PsHttpSSE<IEssentialityClaimSSEResponse>;

    /**
     * 分析 Claim 的必要性
     */
    analyzeClaim(request: IAnalyzeClaimRequest): Promise<IAnalyzeClaimResponse>;

    /**
     * 停止当前分析任务
     */
    stopAnalysis(chatId: string): Promise<{ success: boolean }>;
}

// 依赖注入 Symbol
export const EssentialityClaimChatApiSymbol = Symbol('EssentialityClaimChatApi');
